const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      products: "Products",
      gallery: "Gallery",
      contact: "Contact",
      tagline: "Fresh Meat Daily"
    },
    hero: {
      slogan: "Premium Fresh Meat, Every Day.",
      subtitle: "Your trusted source for halal, fresh, and high-quality meat since day one.",
      ctaProducts: "View Products",
      ctaContact: "Contact Us",
    },
    preorder: {
  title: "Pre-Order for Pickup",
  added: "Added",
  notice: "🚫 No delivery available. This is a pickup-only service. Place your order in advance and collect it at our store at your convenience — we'll have it ready for you!",
  product: "Product",
  name: "Your Name",
  nameHint: "Your name helps the owner identify your order at pickup.",
  namePlaceholder: "e.g. Ahmed, Maria...",
  quantity: "Quantity",
  quantityPlaceholder: "e.g. 2 kg, 3 pieces, half kg...",
  pickupDay: "Pickup Day",
  today: "Today",
  tomorrow: "Tomorrow",
  pickupTime: "Pickup Time",
  pickupPlaceholder: "e.g. 17:00, Around noon...",
  note: "Additional Note (optional)",
  notePlaceholder: "Any special requests or preparation notes...",
  send: "Send via WhatsApp",
  button: "Pre-Order",
  waTitle: "Pre-Order Request — Al-Kasbah",
  waName: "Customer Name",
  waProduct: "Product",
  waQuantity: "Quantity",
  waDay: "Pickup Day",
  waPickup: "Pickup Time",
  waNote: "Note",
  waFooter: "Please confirm my order. Thank you! 🙏",
  products: "Your Order",
item: "Item",
productPlaceholder: "Product name e.g. Chicken Breast",
addItem: "+ Add Another Product",
  consent: "I understand that my pre-order will be sent via WhatsApp (WhatsApp Ireland Ltd. / Meta Platforms) and that data may be transferred to the USA. By submitting, I give my consent.",
  consentLink: "View privacy policy",

},
    intro: {
      title: "Welcome to Al-Kasbah",
      text: "At Al-Kasbah, we take pride in offering the finest selection of fresh, halal-certified meats. From tender chicken to succulent lamb and premium beef, every cut is sourced with care and prepared with tradition. Our commitment to quality, freshness, and hygiene is what sets us apart.",
      freshness: "Daily Fresh",
      freshnessDesc: "All our meats are freshly prepared every single day.",
      halal: "100% Halal",
      halalDesc: "Certified halal sourcing from trusted suppliers.",
      quality: "Premium Quality",
      qualityDesc: "Only the finest cuts make it to our display.",
      hygiene: "Strict Hygiene",
      hygieneDesc: "We follow the highest standards of cleanliness.",
    },
    about: {
      title: "About Us",
      subtitle: "Our Story",
      text1: "Al-Kasbah was founded with a simple mission: to bring the authentic taste and quality of traditional Turkish and Middle Eastern butchery to our community. Our roots run deep in the art of meat preparation, passed down through generations.",
      text2: "We source our meats from trusted local farms, ensuring every piece meets our strict standards for freshness and quality. Our skilled butchers prepare each cut with precision and care, honoring time-tested traditions while embracing modern hygiene standards.",
      text3: "Whether you are looking for everyday essentials or special cuts for a celebration, Al-Kasbah is your destination for meat you can trust.",
      certificates: "Our Features & Certification",
      certHalal: "Halal Certification",
      certHygiene: "Hygiene Standards",
      certQuality: "Quality Assurance",
      certOrganic: "Organic Sourcing",
      quote: "Quality is not a choice here. It's a promise.",
      certHygieneDesc: "We maintain the highest standards of cleanliness in every step of our process.",
      certQualityDesc: "Only the finest cuts make it to our display — inspected and approved daily." ,
      certOrganicDesc: "We source from trusted farms that prioritize natural and responsible practices.",
      certClickToView: "Click to view certificate", 
    },
    products: {
      title: "Our Products",
      subtitle: "Fresh Meat Selection",
      chicken: "Chicken",
      lamb: "Lamb",
      beef: "Beef",
      special: "Special",
      num: "#",
      name: "Product",
      price: "Price",
      disclaimer: "Prices may vary depending on season or demand. For current prices, please refer to our in-store price lists.",
      moreTitle: "Not Just Meat — A Full Oriental Grocery!",
moreSubtitle: "Your Oriental Grocery in Halle (Saale)",
dairy: "Cheese & Dairy",
olivesPickles: "Olives & Pickles",
spicesHerbs: "Spices & Herbs",
riceGrains: "Rice, Legumes & Grains",
breadFrozen: "Bread & Frozen Foods",
snacksSweets: "Snacks & Sweets",
fruitVeg: "Fruit & Vegetables",
      items: {
  lammkeule: "Lamb Leg",
  lammknacken: "Lamb Neck",
  lammschulter: "Lamb Shoulder",
  lammrippen: "Lamb Ribs",
  lammkotelett: "Lamb Chops",
  lammleber: "Lamb Liver",
  lammhackfleisch: "Minced Lamb",
  rinderrippen: "Beef Ribs",
  rinderklugen: "Beef Knuckle",
  rinderhack: "Minced Beef (unseasoned)",
  unterkeule: "Lower Leg",
  kalbskugel: "Veal Round",
  haehnchenbrust: "Chicken Breast",
  haehnchenkeule: "Chicken Leg",
  haehnchenleber: "Chicken Liver",
  haehnchenmagen: "Chicken Gizzard",
  haehnchenfluegel: "Chicken Wings",
  haehnchenherz: "Chicken Heart",
  putenfleisch: "Turkey Meat",
  schaschlik: "Schaschlik Skewers",
},
    },
    gallery: {
  title: "Gallery",
  subtitle: "A Glimpse Into Al-Kasbah",
  viewAll: "View All",   // ← add this
},
    contact: {
      title: "Contact Us",
      subtitle: "For general and business inquiries, see below",
      phone: "Phone",
      email: "Email",
      address: "Address",
      addressValue: "Schmeerstraße 27-28, 06108 Halle(Saale), Germany",
      findUs: "Find Us",
      shopInfo: "Shop 27: Fresh meat , dairy products & deep frozen items · Shop 28: Groceries",
      mapLoadTitle: "Show location on map",
      mapLoadNotice: "By clicking \"Load map\", data (including your IP address) will be transmitted to OpenStreetMap. More information in our privacy policy.",
      mapLoadButton: "Load map",
    },
    footer: {
      hours: "Business Hours",
      monFri: "Monday - Friday",
      saturday: "Saturday",
      sunday: "Sunday",
      closed: "Closed",
      contact: "Contact",
      quickLinks: "Quick Links",
      madeWith: "made with LOVE",
    },
  },
  de: {
    nav: {
      home: "Startseite",
      about: "Ueber Uns",
      products: "Produkte",
      gallery: "Galerie",
      contact: "Kontakt",
      tagline: "Frisches Fleisch täglich"
    },
    hero: {
      slogan: "Premium Frisches Fleisch, Jeden Tag.",
      subtitle: "Ihre vertrauenswuerdige Quelle fuer halal, frisches und hochwertiges Fleisch seit dem ersten Tag.",
      ctaProducts: "Produkte ansehen",
      ctaContact: "Kontaktieren Sie uns",
    },
    preorder: {
  title: "Vorbestellung zur Abholung",
  added: "Hinzugefügt",
  notice: "🚫 Keine Lieferung möglich. Dies ist ein reiner Abholservice. Bestellen Sie im Voraus und holen Sie Ihre Bestellung bequem in unserem Geschäft ab — wir bereiten alles für Sie vor!",
  product: "Produkt",
  name: "Ihr Name",
  nameHint: "Ihr Name hilft dem Inhaber, Ihre Bestellung bei der Abholung zu identifizieren.",
  namePlaceholder: "z.B. Ahmed, Maria...",
  quantity: "Menge",
  quantityPlaceholder: "z.B. 2 kg, 3 Stück, halbes kg...",
  pickupDay: "Abholtag",
  today: "Heute",
  tomorrow: "Morgen",
  pickupTime: "Abholzeit",
  pickupPlaceholder: "z.B. 17:00, Gegen Mittag...",
  note: "Zusätzliche Anmerkung (optional)",
  notePlaceholder: "Besondere Wünsche oder Zubereitungshinweise...",
  send: "Per WhatsApp senden",
  button: "Vorbestellen",
  waTitle: "Vorbestellung — Al-Kasbah",
  waName: "Kundenname",
  waProduct: "Produkt",
  waQuantity: "Menge",
  waDay: "Abholtag",
  waPickup: "Abholzeit",
  waNote: "Anmerkung",
  waFooter: "Bitte bestätigen Sie meine Bestellung. Danke! 🙏",
  products: "Ihre Bestellung",
item: "Artikel",
productPlaceholder: "Produktname z.B. Hähnchenbrust",
addItem: "+ Weiteres Produkt hinzufügen",
  consent: "Mir ist bekannt, dass meine Vorbestellung über WhatsApp (WhatsApp Ireland Ltd. / Meta Platforms) übermittelt wird und dabei Daten auch in die USA übertragen werden können. Mit dem Absenden erkläre ich mein Einverständnis.",
  consentLink: "Zur Datenschutzerklärung",

},
    intro: {
      title: "Willkommen bei Al-Kasbah",
      text: "Bei Al-Kasbah sind wir stolz darauf, die feinste Auswahl an frischem, halal-zertifiziertem Fleisch anzubieten. Von zartem Haehnchen ueber saftiges Lamm bis hin zu erstklassigem Rind wird jedes Stueck sorgfaeltig ausgewaehlt und nach Tradition zubereitet. Unser Engagement fuer Qualitaet, Frische und Hygiene zeichnet uns aus.",
      freshness: "Taeglich Frisch",
      freshnessDesc: "All unser Fleisch wird taeglich frisch zubereitet.",
      halal: "100% Halal",
      halalDesc: "Zertifizierte Halal-Beschaffung von vertrauenswuerdigen Lieferanten.",
      quality: "Premium Qualitaet",
      qualityDesc: "Nur die feinsten Stuecke schaffen es in unsere Auslage.",
      hygiene: "Strenge Hygiene",
      hygieneDesc: "Wir folgen den hoechsten Sauberkeitsstandards.",
    },
    about: {
      title: "Ueber Uns",
      subtitle: "Unsere Geschichte",
      text1: "Al-Kasbah wurde mit einer einfachen Mission gegruendet: den authentischen Geschmack und die Qualitaet traditioneller tuerkischer und nahoeestlicher Metzgerkunst in unsere Gemeinde zu bringen. Unsere Wurzeln reichen tief in die Kunst der Fleischzubereitung, ueberliefert durch Generationen.",
      text2: "Wir beziehen unser Fleisch von vertrauenswuerdigen lokalen Bauernhoefen und stellen sicher, dass jedes Stueck unseren strengen Standards fuer Frische und Qualitaet entspricht. Unsere erfahrenen Metzger bereiten jeden Schnitt mit Praezision und Sorgfalt vor.",
      text3: "Ob Sie nach alltaeglichen Grundnahrungsmitteln oder speziellen Stuecken fuer eine Feier suchen, Al-Kasbah ist Ihr Ziel fuer Fleisch, dem Sie vertrauen koennen.",
      certificates: "Unsere Merkmale & Zertifizierung",
      certHalal: "Halal-Zertifizierung",
      certHygiene: "Hygienestandards",
      certQuality: "Qualitaetssicherung",
      certOrganic: "Bio-Beschaffung",
      certHygieneDesc: "Wir halten höchste Hygienestandards in jedem Schritt unseres Prozesses ein.",
certQualityDesc: "Nur die besten Stücke kommen in unsere Auslage — täglich geprüft und freigegeben.",
certOrganicDesc: "Wir beziehen von vertrauenswürdigen Betrieben, die natürliche Praktiken bevorzugen.",
      quote: "Qualität ist hier keine Wahl. Es ist ein Versprechen.",
      certClickToView: "Zum Anzeigen klicken",
    },
    products: {
      title: "Unsere Produkte",
      subtitle: "Frische Fleischauswahl",
      chicken: "Haehnchen",
      lamb: "Lamm",
      beef: "Rind",
      special: "Spezial",
      num: "#",
      name: "Produkt",
      price: "Preis",
      disclaimer: "Die Preise koennen je nach Saison oder Nachfrage variieren. Fuer aktuelle Preise beziehen Sie sich bitte auf unsere Preislisten im Geschaeft.",
      moreTitle: "Nicht nur Fleisch — Ein ganzer Supermarkt!",
moreSubtitle: "Ihr orientalischer Supermarkt in Halle (Saale)",
dairy: "Käse & Milchprodukte",
olivesPickles: "Oliven & Konserven",
spicesHerbs: "Gewürze & Kräuter",
riceGrains: "Reis, Hülsenfrüchte & Getreide",
breadFrozen: "Brot & Tiefkühlkost",
snacksSweets: "Snacks & Süßigkeiten",
fruitVeg: "Obst & Gemüse",
      items: {
  lammkeule: "Lammkeule",
  lammknacken: "Lammknacken",
  lammschulter: "Lammschulter",
  lammrippen: "Lammrippen",
  lammkotelett: "Lammkotelett",
  lammleber: "Lammleber",
  lammhackfleisch: "Lammhackfleisch",
  rinderrippen: "Rinderrippen",
  rinderklugen: "Rinderklugen",
  rinderhack: "Rinderhack (ohne Gewürz)",
  unterkeule: "Unterkeule",
  kalbskugel: "Kalbskugel",
  haehnchenbrust: "Hähnchenbrust",
  haehnchenkeule: "Hähnchenkeule",
  haehnchenleber: "Hähnchenleber",
  haehnchenmagen: "Hähnchenmagen",
  haehnchenfluegel: "Hähnchenflügel",
  haehnchenherz: "Hähnchenherz",
  putenfleisch: "Putenfleisch",
  schaschlik: "Schaschlik",
},
    },
   gallery: {
  title: "Galerie",
  subtitle: "Ein Blick in Al-Kasbah",
  viewAll: "Alle ansehen",
},
    contact: {
      title: "Kontakt",
      subtitle: "Fuer allgemeine und geschaeftliche Anfragen siehe unten",
      phone: "Telefon",
      email: "E-Mail",
      address: "Adresse",
      addressValue: "Schmeerstraße 27-28, 06108 Halle(Saale), Deutschland",
      findUs: "Finden Sie uns",
      shopInfo: "Laden 27: Frisches Fleisch, Milchprodukte & Tiefkühlwaren ; Laden 28: Lebensmittel",
      mapLoadTitle: "Standort auf Karte anzeigen",
      mapLoadNotice: "Mit dem Klick auf \"Karte laden\" werden Daten (u. a. Ihre IP-Adresse) an OpenStreetMap übertragen. Weitere Informationen in unserer Datenschutzerklärung.",
      mapLoadButton: "Karte laden",

    },
    footer: {
      hours: "Oeffnungszeiten",
      monFri: "Montag - Freitag",
      saturday: "Samstag",
      sunday: "Sonntag",
      closed: "Geschlossen",
      contact: "Kontakt",
      quickLinks: "Schnelllinks",
      madeWith: "made with LOVE",
    },
  },
  ar: {
    nav: {
      home: "\u0627\u0644\u0631\u0626\u064a\u0633\u064a\u0629",
      about: "\u0645\u0646 \u0646\u062d\u0646",
      products: "\u0627\u0644\u0645\u0646\u062a\u062c\u0627\u062a",
      gallery: "\u0627\u0644\u0645\u0639\u0631\u0636",
      contact: "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
      tagline: "لحم طازج يومياً"
    },
    hero: {
      slogan: "\u0644\u062d\u0648\u0645 \u0637\u0627\u0632\u062c\u0629 \u0645\u0645\u062a\u0627\u0632\u0629\u060c \u0643\u0644 \u064a\u0648\u0645.",
      subtitle: "\u0645\u0635\u062f\u0631\u0643 \u0627\u0644\u0645\u0648\u062b\u0648\u0642 \u0644\u0644\u062d\u0648\u0645 \u0627\u0644\u062d\u0644\u0627\u0644 \u0627\u0644\u0637\u0627\u0632\u062c\u0629 \u0648\u0639\u0627\u0644\u064a\u0629 \u0627\u0644\u062c\u0648\u062f\u0629 \u0645\u0646\u0630 \u0627\u0644\u064a\u0648\u0645 \u0627\u0644\u0623\u0648\u0644.",
      ctaProducts: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0646\u062a\u062c\u0627\u062a",
      ctaContact: "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
    },
    preorder: {
  title: "طلب مسبق للاستلام",
  added: "تمت الإضافة",
  notice: "🚫 لا يوجد توصيل. هذه خدمة استلام فقط. قدّم طلبك مسبقاً واستلمه من متجرنا في الوقت المناسب لك — سنقوم بتجهيزه قبل وصولك!",
  product: "المنتج",
  name: "اسمك",
  nameHint: "اسمك يساعد صاحب المتجر على التعرف على طلبك عند الاستلام.",
  namePlaceholder: "مثال: أحمد، ماريا...",
  quantity: "الكمية",
  quantityPlaceholder: "مثال: 2 كيلو، 3 قطع، نصف كيلو...",
  pickupDay: "يوم الاستلام",
  today: "اليوم",
  tomorrow: "غداً",
  pickupTime: "وقت الاستلام",
  pickupPlaceholder: "مثال: الساعة 17:00، قرب الظهر...",
  note: "ملاحظة إضافية (اختياري)",
  notePlaceholder: "أي طلبات خاصة أو ملاحظات تحضير...",
  send: "إرسال عبر واتساب",
  button: "طلب مسبق",
  waTitle: "طلب مسبق — القصبة",
  waName: "اسم العميل",
  waProduct: "المنتج",
  waQuantity: "الكمية",
  waDay: "يوم الاستلام",
  waPickup: "وقت الاستلام",
  waNote: "ملاحظة",
  waFooter: "يرجى تأكيد طلبي. شكراً! 🙏",
  products: "طلبك",
item: "عنصر",
productPlaceholder: "اسم المنتج مثال: صدر دجاج",
addItem: "+ إضافة منتج آخر",

  consent: "أفهم أن طلبي المسبق سيتم إرساله عبر واتساب (WhatsApp Ireland Ltd. / Meta Platforms) وأن البيانات قد يتم نقلها إلى الولايات المتحدة. بالإرسال، أُعطي موافقتي.",
  consentLink: "عرض سياسة الخصوصية",

},
    intro: {
      title: "\u0645\u0631\u062d\u0628\u0627 \u0628\u0643\u0645 \u0641\u064a \u0627\u0644\u0642\u0635\u0628\u0629",
      text: "\u0641\u064a \u0627\u0644\u0642\u0635\u0628\u0629\u060c \u0646\u0641\u062e\u0631 \u0628\u062a\u0642\u062f\u064a\u0645 \u0623\u0641\u0636\u0644 \u062a\u0634\u0643\u064a\u0644\u0629 \u0645\u0646 \u0627\u0644\u0644\u062d\u0648\u0645 \u0627\u0644\u0637\u0627\u0632\u062c\u0629 \u0627\u0644\u0645\u0639\u062a\u0645\u062f\u0629 \u062d\u0644\u0627\u0644. \u0645\u0646 \u0627\u0644\u062f\u062c\u0627\u062c \u0627\u0644\u0637\u0631\u064a \u0625\u0644\u0649 \u0644\u062d\u0645 \u0627\u0644\u063a\u0646\u0645 \u0627\u0644\u0639\u0635\u064a\u0631 \u0648\u0644\u062d\u0645 \u0627\u0644\u0628\u0642\u0631 \u0627\u0644\u0645\u0645\u062a\u0627\u0632\u060c \u064a\u062a\u0645 \u0627\u062e\u062a\u064a\u0627\u0631 \u0643\u0644 \u0642\u0637\u0639\u0629 \u0628\u0639\u0646\u0627\u064a\u0629 \u0648\u062a\u062d\u0636\u064a\u0631\u0647\u0627 \u0628\u0627\u0644\u062a\u0642\u0627\u0644\u064a\u062f.",
      freshness: "\u0637\u0627\u0632\u062c \u064a\u0648\u0645\u064a\u0627",
      freshnessDesc: "\u062c\u0645\u064a\u0639 \u0644\u062d\u0648\u0645\u0646\u0627 \u064a\u062a\u0645 \u062a\u062d\u0636\u064a\u0631\u0647\u0627 \u0637\u0627\u0632\u062c\u0629 \u0643\u0644 \u064a\u0648\u0645.",
      halal: "\u062d\u0644\u0627\u0644 100%",
      halalDesc: "\u0645\u0635\u0627\u062f\u0631 \u062d\u0644\u0627\u0644 \u0645\u0639\u062a\u0645\u062f\u0629 \u0645\u0646 \u0645\u0648\u0631\u062f\u064a\u0646 \u0645\u0648\u062b\u0648\u0642\u064a\u0646.",
      quality: "\u062c\u0648\u062f\u0629 \u0645\u0645\u062a\u0627\u0632\u0629",
      qualityDesc: "\u0641\u0642\u0637 \u0623\u0641\u0636\u0644 \u0627\u0644\u0642\u0637\u0639 \u062a\u0635\u0644 \u0625\u0644\u0649 \u0639\u0631\u0636\u0646\u0627.",
      hygiene: "\u0646\u0638\u0627\u0641\u0629 \u0635\u0627\u0631\u0645\u0629",
      hygieneDesc: "\u0646\u062a\u0628\u0639 \u0623\u0639\u0644\u0649 \u0645\u0639\u0627\u064a\u064a\u0631 \u0627\u0644\u0646\u0638\u0627\u0641\u0629.",
    },
    about: {
      title: "\u0645\u0646 \u0646\u062d\u0646",
      subtitle: "\u0642\u0635\u062a\u0646\u0627",
      text1: "\u062a\u0623\u0633\u0633\u062a \u0627\u0644\u0642\u0635\u0628\u0629 \u0628\u0645\u0647\u0645\u0629 \u0628\u0633\u064a\u0637\u0629: \u062c\u0644\u0628 \u0627\u0644\u0637\u0639\u0645 \u0627\u0644\u0623\u0635\u064a\u0644 \u0648\u062c\u0648\u062f\u0629 \u0627\u0644\u0645\u0644\u062d\u0645\u0629 \u0627\u0644\u062a\u0631\u0643\u064a\u0629 \u0648\u0627\u0644\u0634\u0631\u0642 \u0623\u0648\u0633\u0637\u064a\u0629 \u0627\u0644\u062a\u0642\u0644\u064a\u062f\u064a\u0629 \u0625\u0644\u0649 \u0645\u062c\u062a\u0645\u0639\u0646\u0627. \u062c\u0630\u0648\u0631\u0646\u0627 \u0639\u0645\u064a\u0642\u0629 \u0641\u064a \u0641\u0646 \u062a\u062d\u0636\u064a\u0631 \u0627\u0644\u0644\u062d\u0648\u0645\u060c \u0645\u062a\u0648\u0627\u0631\u062b\u0629 \u0639\u0628\u0631 \u0627\u0644\u0623\u062c\u064a\u0627\u0644.",
      text2: "\u0646\u062d\u0635\u0644 \u0639\u0644\u0649 \u0644\u062d\u0648\u0645\u0646\u0627 \u0645\u0646 \u0645\u0632\u0627\u0631\u0639 \u0645\u062d\u0644\u064a\u0629 \u0645\u0648\u062b\u0648\u0642\u0629\u060c \u0648\u0646\u0636\u0645\u0646 \u0623\u0646 \u0643\u0644 \u0642\u0637\u0639\u0629 \u062a\u0644\u0628\u064a \u0645\u0639\u0627\u064a\u064a\u0631\u0646\u0627 \u0627\u0644\u0635\u0627\u0631\u0645\u0629 \u0644\u0644\u0637\u0632\u0627\u062c\u0629 \u0648\u0627\u0644\u062c\u0648\u062f\u0629. \u064a\u0642\u0648\u0645 \u062c\u0632\u0627\u0631\u0648\u0646\u0627 \u0627\u0644\u0645\u0647\u0631\u0629 \u0628\u062a\u062d\u0636\u064a\u0631 \u0643\u0644 \u0642\u0637\u0639\u0629 \u0628\u062f\u0642\u0629 \u0648\u0639\u0646\u0627\u064a\u0629.",
      text3: "\u0633\u0648\u0627\u0621 \u0643\u0646\u062a \u062a\u0628\u062d\u062b \u0639\u0646 \u0627\u0644\u0623\u0633\u0627\u0633\u064a\u0627\u062a \u0627\u0644\u064a\u0648\u0645\u064a\u0629 \u0623\u0648 \u0642\u0637\u0639 \u062e\u0627\u0635\u0629 \u0644\u0644\u0627\u062d\u062a\u0641\u0627\u0644\u060c \u0627\u0644\u0642\u0635\u0628\u0629 \u0647\u064a \u0648\u062c\u0647\u062a\u0643 \u0644\u0644\u062d\u0648\u0645 \u0627\u0644\u062a\u064a \u064a\u0645\u0643\u0646\u0643 \u0627\u0644\u0648\u062b\u0648\u0642 \u0628\u0647\u0627.",
      certificates: "مميزاتنا وشهادتنا",
      certHalal: "\u0634\u0647\u0627\u062f\u0629 \u062d\u0644\u0627\u0644",
      certHygiene: "\u0645\u0639\u0627\u064a\u064a\u0631 \u0627\u0644\u0646\u0638\u0627\u0641\u0629",
      certQuality: "\u0636\u0645\u0627\u0646 \u0627\u0644\u062c\u0648\u062f\u0629",
      certOrganic: "\u0645\u0635\u0627\u062f\u0631 \u0639\u0636\u0648\u064a\u0629",
      certHygieneDesc: "نحافظ على أعلى معايير النظافة في كل خطوة من خطوات عملنا.",
certQualityDesc: "فقط أفضل القطع تصل إلى عرضنا — يتم فحصها والموافقة عليها يومياً.",
certOrganicDesc: "نحصل على منتجاتنا من مزارع موثوقة تُعطي الأولوية للممارسات الطبيعية.",
      quote: "الجودة ليست خياراً هنا. إنها وعد.",
      certClickToView: "انقر للعرض",
    },
    products: {
      title: "\u0645\u0646\u062a\u062c\u0627\u062a\u0646\u0627",
      subtitle: "\u062a\u0634\u0643\u064a\u0644\u0629 \u0627\u0644\u0644\u062d\u0648\u0645 \u0627\u0644\u0637\u0627\u0632\u062c\u0629",
      chicken: "\u062f\u062c\u0627\u062c",
      lamb: "\u0644\u062d\u0645 \u063a\u0646\u0645",
      beef: "\u0644\u062d\u0645 \u0628\u0642\u0631",
      special: "\u062e\u0627\u0635",
      num: "#",
      name: "\u0627\u0644\u0645\u0646\u062a\u062c",
      price: "\u0627\u0644\u0633\u0639\u0631",
      disclaimer: "\u0642\u062f \u062a\u062e\u062a\u0644\u0641 \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u062d\u0633\u0628 \u0627\u0644\u0645\u0648\u0633\u0645 \u0623\u0648 \u0627\u0644\u0637\u0644\u0628. \u0644\u0644\u0623\u0633\u0639\u0627\u0631 \u0627\u0644\u062d\u0627\u0644\u064a\u0629\u060c \u064a\u0631\u062c\u0649 \u0627\u0644\u0631\u062c\u0648\u0639 \u0625\u0644\u0649 \u0642\u0648\u0627\u0626\u0645 \u0627\u0644\u0623\u0633\u0639\u0627\u0631 \u0641\u064a \u0627\u0644\u0645\u062a\u062c\u0631.",
      moreTitle: "ليس فقط لحوماً — سوبرماركت شرقي كامل!",
moreSubtitle: "بقالتك الشرقية في هاله (زاله)",
dairy: "جبن ومنتجات الألبان",
olivesPickles: "زيتون ومخللات",
spicesHerbs: "بهارات وأعشاب",
riceGrains: "أرز وبقوليات وحبوب",
breadFrozen: "خبز وأطعمة مجمدة",
snacksSweets: "وجبات خفيفة وحلويات",
fruitVeg: "فواكه وخضروات",
      items: {
  lammkeule: "فخذ الخروف",
  lammknacken: "رقبة الخروف",
  lammschulter: "كتف الخروف",
  lammrippen: "ضلوع الخروف",
  lammkotelett: "ريش الخروف",
  lammleber: "كبد الخروف",
  lammhackfleisch: "لحم خروف مفروم",
  rinderrippen: "ضلوع البقر",
  rinderklugen: "كنكل البقر",
  rinderhack: "لحم بقر مفروم (بدون توابل)",
  unterkeule: "الساق السفلية",
  kalbskugel: "كرة العجل",
  haehnchenbrust: "صدر الدجاج",
  haehnchenkeule: "فخذ الدجاج",
  haehnchenleber: "كبد الدجاج",
  haehnchenmagen: "قانصة الدجاج",
  haehnchenfluegel: "أجنحة الدجاج",
  haehnchenherz: "قلب الدجاج",
  putenfleisch: "لحم الديك الرومي",
  schaschlik: "شيش طاووق",
},
    },
   gallery: {
  title: "المعرض",
  subtitle: "لمحة عن القصبة",
  viewAll: "عرض الكل",
},

    contact: {
      title: "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
      subtitle: "\u0644\u0644\u0627\u0633\u062a\u0641\u0633\u0627\u0631\u0627\u062a \u0627\u0644\u0639\u0627\u0645\u0629 \u0648\u0627\u0644\u062a\u062c\u0627\u0631\u064a\u0629 \u0627\u0646\u0638\u0631 \u0623\u062f\u0646\u0627\u0647",
      phone: "\u0627\u0644\u0647\u0627\u062a\u0641",
      email: "\u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",
      address: "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
      addressValue: "شميرشتراسه 27-28، 06108 هاله (زاله)، ألمانيا",
      findUs: "\u0627\u0639\u062b\u0631 \u0639\u0644\u064a\u0646\u0627",
      shopInfo: "المتجر رقم 27: لحوم طازجة، منتجات ألبان، ومواد مجمدة. المتجر رقم 28: مواد البقالة.",
      mapLoadTitle : "عرض الموقع على الخريطة",
     mapLoadNotice: "بالنقر على \"تحميل الخريطة\"، سيتم نقل البيانات (بما في ذلك عنوان IP الخاص بك) إلى OpenStreetMap. مزيد من المعلومات في سياسة الخصوصية الخاصة بنا.",
     mapLoadButton: "تحميل الخريطة",
    },
    footer: {
      hours: "\u0633\u0627\u0639\u0627\u062a \u0627\u0644\u0639\u0645\u0644",
      monFri: "\u0627\u0644\u0627\u062b\u0646\u064a\u0646 - \u0627\u0644\u062c\u0645\u0639\u0629",
      saturday: "\u0627\u0644\u0633\u0628\u062a",
      sunday: "\u0627\u0644\u0623\u062d\u062f",
      closed: "\u0645\u063a\u0644\u0642",
      contact: "\u0627\u062a\u0635\u0644 \u0628\u0646\u0627",
      quickLinks: "\u0631\u0648\u0627\u0628\u0637 \u0633\u0631\u064a\u0639\u0629",
      madeWith: "made with LOVE",
    },
  },
};

export default translations;
